import BinIcon from '../../../../../components/icon/Icon';
import { closeMobileSliderPageAction } from '../../../../mobileAppActions';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import appHistory from '../../../../../app/appHistory';
import { MobileSliderPagesCloseButtonStyled } from './styled/MobileSliderPagesCloseButtonStyled';

export interface IMobileSliderPagesCloseButtonProps {
    className?: string;
    closeButtonIcon?: string;
    goBack?: boolean;
    onClick?: () => void;
    onClickHandler?: () => void;
}

function MobileSliderPagesCloseButton(props: IMobileSliderPagesCloseButtonProps) {
    const {
        className,
        closeButtonIcon,
        goBack,
        onClick,
        onClickHandler,
    } = props;

    const dispatch = useDispatch();

    const handleClick = useCallback(() => {
        if (onClickHandler) return onClickHandler();
        onClick && onClick();
        if (!goBack) {
            dispatch(closeMobileSliderPageAction());
        } else {
            appHistory.goBack();
        }
    }, [dispatch, onClickHandler, goBack, onClick]);

    return <MobileSliderPagesCloseButtonStyled className={className} onClick={handleClick}>
        <BinIcon name={closeButtonIcon || (goBack ? 'IcBack' : 'IcXMark')} size={24}/>
    </MobileSliderPagesCloseButtonStyled>;
}

export default MobileSliderPagesCloseButton;
